<script setup>
import BlogPostBlock from "@/components/BlogPostBlock.vue";

const blogPosts = [
  {
    title: "From the Sidelines to the Boardroom: My Growth Journey",
    image: "/images/ashley-friel-blog-post-1.jpg",
    excerpt:
      "Life is an ongoing learning game, and I am always up for a new level! Be it on the field as the team's coach or in a classroom setting learning about business...",
    route: "/blog/1",
  },
  {
    title: "Spreading Sunshine: My Passion for People and Positivity",
    image: "/images/ashley-friel-blog-post-2.jpg",
    excerpt:
      "Positivity has always been one of my defining traits. Yes, even with a busy work schedule, a tough day at school, or a battle in team sports, I believe that exchanging...",
    route: "/blog/2",
  },
];
</script>

<template>
  <section id="blog-section">
    <h2 class="section-title">Blog</h2>
    <p class="section-text mt-4">
      This is where I share thoughts, stories, and things I find interesting. Nothing fancy—just a place to write,
      reflect, and maybe spark a good conversation.
    </p>
    <div class="blog-grid mt-4">
      <BlogPostBlock v-for="blogPost in blogPosts" :blog-post="blogPost" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.blog-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
}
</style>
